import * as React from 'react'

import type { InputProps } from '../input/Input'

export type FormCustomContextType =
  | {
      appearance?: InputProps['appearance']
      theme?: InputProps['theme']
    }
  | undefined

export const FormCustomContext = React.createContext<FormCustomContextType>({
  appearance: 'standard'
})

export const useFormCustomContext = () => React.useContext(FormCustomContext)
